import React from 'react';
import Skillcard from './Skillcard';
import { motion } from 'framer-motion';
import { skills } from '../data/about_data';
import { FaHeart } from 'react-icons/fa';

const about_variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.1,
      duration: 0.2,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: 'easeInOut',
    },
  },
};

const About = () => {
  return (
    <motion.div
      className='about'
      variants={about_variants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      <h6 className='about__intro'>
        <p>
          Hey! I'm <strong>Emiliano</strong> from Argentina, a former IT
          Technician now dedicated to Front-End development. I love to learn new
          things and solve puzzles... I guess that's what drove me to coding in
          the first place <FaHeart className='about__icon-smile' />.
          <br />I can speak 3 languages (Spanish, English & Portuguese) and lick
          my own elbow.
        </p>
      </h6>
      <div className='container about__container'>
        {/* <h6 className='about__heading'>What I do...</h6> */}
        <div className='row'>
          {skills.map((skill) => (
            <Skillcard skill={skill} key={skill.id} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default About;
